import React, {
    Component
} from 'react';
import classNames from 'classnames';

import OLMap from 'ol/Map';
import View from 'ol/View';
import Stamen from 'ol/source/Stamen';
import XYZLayer from 'ol/source/XYZ';

import LayerGroup from 'ol/layer/Group';
import LayerTile from 'ol/layer/Tile';
import LayerVector from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature'
// import WKT from 'ol/format/WKT';
import GeoJSON from 'ol/format/GeoJSON';
import {fromLonLat} from 'ol/proj'
import {getCenter} from 'ol/extent'
import Overlay from 'ol/Overlay'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import Draw from 'ol/interaction/Draw.js';

import '../../styling/Map.css';
import 'ol/ol.css';

// -110.4431847862801135,31.4716043362413380 : -110.3311009717660909,31.6393081000344338
const projection = {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:3857'
};

class Map extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopup: false,
            selectedFeature: null,
            drawnBuildingId: 0,
            drawnFencelineId: 0,
        };
    };

    componentDidUpdate(prevProps, prevState) {
        // Toggle coverage interactions
        if (this.props.drawBuilding) {
            this.state.map.addInteraction(this.state.drawBuilding);
        } else {
            this.state.map.removeInteraction(this.state.drawBuilding);
        }

        if (this.props.drawFenceline) {
            this.state.map.addInteraction(this.state.drawFenceline);
        } else {
            this.state.map.removeInteraction(this.state.drawFenceline);
        }

        if (this.props.clearBuildings) {
            this.clearDrawnBuildings()
        }

        if (this.props.clearFencelines) {
            this.clearDrawnFencelines()
        }

        if (prevProps.facilityLat !== this.props.facilityLat || prevProps.facilityLon !== this.props.facilityLon){
            if (typeof(this.props.facilityLat) !== "undefined" && typeof(this.props.facilityLon) !== "undefined") {
                let map = this.mapFacilityLocation(this.state.map)
                this.setState({map: map})
            }
        }

        if (prevProps.facilitySource !== this.props.facilitySource){
            if (typeof(this.props.facilitySource) !== "undefined") {
                let map = this.mapFacilitySource(this.state.map)
                this.setState({map: map})
            }
        }

        if (prevProps.buildingGeojson !== this.props.buildingGeojson){
            this.updateBuildingGeojson()
        }
        if (prevProps.fencelineGeojson !== this.props.fencelineGeojson){
            this.updateFencelineGeojson()
        }
        if (prevProps.selectedCustomHeight !== this.props.selectedCustomHeight){
            this.updateDisplayedHeights()
        }
        if (prevProps.drawnBuildings !== this.props.drawnBuildings){
            this.updateDisplayedHeights()
        }
        if (prevProps.drawnFencelines !== this.props.drawnFencelines){
            this.updateDisplayedHeights()
        }

        if (typeof(this.props.facilityLat) !== "undefined" && typeof(this.props.facilityLon) !== "undefined") {
            if (Array.isArray(this.props.surfaceStationList) && this.props.surfaceStationList.length > 0){
                this.mapSurfaceStations()
            }
            if (Array.isArray(this.props.upperAirStationList) && this.props.upperAirStationList.length > 0){
                this.mapUpperAirStations()
            }
        }

    }

    render() {
        return (
            <div>
                <div className={classNames(this.props.classes.margin, "Map")} ref="mapContainer">
                    {this.state.showPopup && <div ref="popup" className={classNames("ol-popup")}>
                        <div ref="popupContent"></div>
                    </div>}
                </div>

            </div>
        );
    }


    componentDidMount() {
        // WKT and GeoJSON objects for later
        // const wkt = new WKT();
        const geojson = new GeoJSON();

        // Coverage style, layer, and vector source
        let buildingGeojson = new LayerVector({
            source: new VectorSource({
                wrapX: false
            }),
            style: [
                new Style({
                    fill: new Fill({
                      color: 'rgba(0, 0, 255, 0.3)'
                    }),
                    stroke: new Stroke({
                        color: 'blue',
                        width: 2
                    })
            })],
            name: 'buildingGeojson'
        });

        let fencelineGeojson = new LayerVector({
            source: new VectorSource({
                wrapX: false
            }),
            style: [
                new Style({
                    stroke: new Stroke({
                        color: '#FFC700',
                        width: 2
                    })
            })],
            name: 'fencelineGeojson'
        });

        let drawnBuildings = new LayerVector({
            source: new VectorSource({
                wrapX: false
            }),
            style: [
                new Style({
                    stroke: new Stroke({
                        color: '#17e8da',
                        width: 2
                    }),
                    fill: new Fill({
                      color: 'rgba(23, 232, 218, .3)'
                    }),
                })],
            name: 'drawnBuildings'
        });

        let drawnFencelines = new LayerVector({
            source: new VectorSource({
                wrapX: false
            }),
            style: [
                new Style({
                    stroke: new Stroke({
                        color: 'yellow',
                        width: 2
                    })
                })],
            name: 'drawnFencelines'
        });

        // create map object with feature layer
        let map = new OLMap({
            target: this.refs.mapContainer,
            layers: [
                new LayerGroup({
                    layers: [
                        new LayerTile({
                            source:new XYZLayer({
                              url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.jpg'
                            })
                        })
                    ]
                }),
                buildingGeojson,
                fencelineGeojson,
                drawnBuildings,
                drawnFencelines,
            ],
            view: new View({
                center: [0, 0],
                zoom: 2,
            })
        });

        if (this.props.facilityLat && this.props.facilityLon){
            map = this.mapFacilityLocation(map)
        }

        if (this.props.facilitySource){
            map = this.mapFacilitySource(map)
        }

        if (typeof this.props.drawBuilding !== 'undefined') {
            map.on('click', this.handleBuildingMapClick.bind(this))
        } else if (typeof this.props.surfaceStationList !== 'undefined') {
            map.on('click', this.handleMetMapClick.bind(this));
        }

        let drawBuilding = new Draw({
            source: drawnBuildings.getSource(),
            type: 'Polygon',
            geometryName: 'draw'
        });

        // Handle draw end events
        drawBuilding.on('drawend', (event) => {
            map.removeInteraction(drawBuilding);
            this.props.changeBoolean('drawBuilding')

            let drawnBuildingId = this.state.drawnBuildingId
            event.feature.setProperties({
                '_customType': 'drawnBuildings',
                '_customHeight': 3,
                '_customId': drawnBuildingId
            })

            this.setState({drawnBuildingId: drawnBuildingId +1})

            let drawnBuildings = this.props.drawnBuildings
            let thisDraw = geojson.writeFeatureObject(event.feature)
            console.log(thisDraw)
            drawnBuildings.push(thisDraw)
            this.props.handleInputChange({
                'target': {
                    'type': 'input',
                    'name': 'drawnBuildings',
                    'value': drawnBuildings
            }})
        });

        let drawFenceline = new Draw({
            source: drawnFencelines.getSource(),
            type: 'Polygon',
            geometryName: 'draw'
        });

        drawFenceline.on('drawend', (event) => {
            map.removeInteraction(drawFenceline);
            this.props.changeBoolean('drawFenceline')

            let drawnFencelineId = this.state.drawnFencelineId
            event.feature.setProperties({
                '_customType': 'drawnFencelines',
                '_customHeight': 3,
                '_customId': drawnFencelineId
            })

            this.setState({drawnFencelineId: drawnFencelineId +1})

            let drawnFencelines = this.props.drawnFencelines
            let thisDraw = geojson.writeFeatureObject(event.feature)
            drawnFencelines.push(thisDraw)
            this.props.handleInputChange({
                'target': {
                    'type': 'input',
                    'name': 'drawnFencelines',
                    'value': drawnFencelines
            }})
        });



        // save map and layer references to local state
        this.setState({
            map: map,
            drawnBuildings: drawnBuildings,
            drawnFencelines: drawnFencelines,
            buildingGeojson: buildingGeojson,
            fencelineGeojson: fencelineGeojson,
            drawBuilding: drawBuilding,
            drawFenceline: drawFenceline
        });
    }

    updateFencelineGeojson(){
        const shp2geojson = this.props.fencelineGeojson
        if (shp2geojson !== null && 'features' in shp2geojson) {

            let fencelineGeojson = this.state.fencelineGeojson
            let source = fencelineGeojson.getSource()
            source.clear()

            shp2geojson.features.forEach(feature => {
                 source.addFeatures([(new GeoJSON(projection)).readFeature(feature)])
            })

            fencelineGeojson.setSource(source)
            let extent = source.getExtent()
            this.state.map.getView().fit(extent,  {size:this.state.map.getSize(), maxZoom:15})
            this.setState({fencelineGeojson: fencelineGeojson})
        } else {
            let fencelineGeojson = this.state.fencelineGeojson
            let source = fencelineGeojson.getSource()
            source.clear()
        }
    }

    updateBuildingGeojson(){
        const shp2geojson = this.props.buildingGeojson
        if (shp2geojson !== null && 'features' in shp2geojson) {

            let buildingGeojson = this.state.buildingGeojson
            let source = buildingGeojson.getSource()
            source.clear()

            shp2geojson.features.forEach(feature => {
                 source.addFeatures([(new GeoJSON(projection)).readFeature(feature)])
            })

            buildingGeojson.setSource(source)
            let extent = source.getExtent()
            this.state.map.getView().fit(extent,  {size:this.state.map.getSize(), maxZoom:15})
            this.setState({buildingGeojson: buildingGeojson})

        } else {
            let buildingGeojson = this.state.buildingGeojson
            let source = buildingGeojson.getSource()
            source.clear()
        }

    }

    updateDisplayedHeights(){
        if (this.props.buildingGeojson !== null && 'features' in this.props.buildingGeojson) {

            let buildingGeojson = this.state.buildingGeojson
            let source = buildingGeojson.getSource()
            source.clear()

            this.props.buildingGeojson.features.forEach(feature => {
                 source.addFeatures([(new GeoJSON(projection)).readFeature(feature)])
            })

            buildingGeojson.setSource(source)
            this.setState({buildingGeojson: buildingGeojson})
        }
        if (this.props.fencelineGeojson !== null && 'features' in this.props.fencelineGeojson) {

            let fencelineGeojson = this.state.fencelineGeojson
            let source = fencelineGeojson.getSource()
            source.clear()

            this.props.fencelineGeojson.features.forEach(feature => {
                 source.addFeatures([(new GeoJSON(projection)).readFeature(feature)])
            })

            fencelineGeojson.setSource(source)
            this.setState({fencelineGeojson: fencelineGeojson})
        }
        if (this.props.drawnBuildings !== undefined && this.props.drawnBuildings.length !== 0){
            let drawnBuildings = this.state.drawnBuildings
            let source = drawnBuildings.getSource()
            source.clear()

            this.props.drawnBuildings.forEach(feature => {
                source.addFeatures([(new GeoJSON()).readFeature(feature)])
            })
            drawnBuildings.setSource(source)
            this.setState({drawnBuildings: drawnBuildings})
        }
        if (this.props.buildingLocationFile === null){
            let drawnBuildings = this.state.drawnBuildings
            let source = drawnBuildings.getSource()
            source.clear()
            drawnBuildings.setSource(source)
            this.setState({drawnBuildings: drawnBuildings})
        }
        if (this.props.drawnFencelines !== undefined && this.props.drawnFencelines.length !== 0){
            let drawnFencelines = this.state.drawnFencelines
            let source = drawnFencelines.getSource()
            source.clear()

            this.props.drawnFencelines.forEach(feature => {
                source.addFeatures([(new GeoJSON()).readFeature(feature)])
            })
            drawnFencelines.setSource(source)
            this.setState({drawnFencelines: drawnFencelines})
        }
        if (this.props.fenceLineLocationFile === null){
            let drawnFencelines = this.state.drawnFencelines
            let source = drawnFencelines.getSource()
            source.clear()
            drawnFencelines.setSource(source)
            this.setState({drawnFencelines: drawnFencelines})
        }

        let container = this.refs.popup
        let content_element = this.refs.popupContent

        let overlay = new Overlay({
            element: container,
            autoPan: true,
            offset: [0, -10]
        });

        let feature = this.state.selectedFeature

        if (feature) {
            overlay.setPosition(null);

            let center = getCenter(feature.getGeometry().getExtent())

            let _customType = feature.get('_customType')
            let typeName = ''
            if (_customType === 'buildingGeojson'){
                typeName = 'Building'
            } else if (_customType === 'fencelineGeojson') {
                typeName = 'Fenceline'
            } else if (_customType === 'drawnBuildings') {
                typeName = 'User defined building'
            } else if (_customType === 'drawnFencelines') {
                typeName = 'User defined fenceline'
            }
            let _customId = feature.get('_customId')
            let _customHeight = this.props.selectedCustomHeight

            let content = `<h4> ${typeName}: ${_customId} </h4> <p> Height: ${_customHeight}m</p>`
            this.state.map.addOverlay(overlay);

            content_element.innerHTML = content;
            overlay.setPosition(center);
            this.props.setGeojsonInfo(_customType, _customId, _customHeight)

        }

    }

    clearDrawnFencelines(){
        let container = this.refs.popup
        let overlay = new Overlay({
            element: container,
            autoPan: true,
            offset: [0, -10]
        });

        let feature = this.state.selectedFeature

        if (feature) {
            this.setState({selectedFeature: null})
            this.props.setGeojsonInfo('', '', '')

            this.props.setBoolean('showNumberInput', false)
            overlay.setPosition(null);
        }

        this.state.drawnFencelines.getSource().clear()
        this.props.changeBoolean('clearFencelines')
        this.props.handleInputChange({
            'target': {
                'type': 'input',
                'name': 'drawnFencelines',
                'value': []
        }})
    }

    clearDrawnBuildings(){
        let container = this.refs.popup
        let overlay = new Overlay({
            element: container,
            autoPan: true,
            offset: [0, -10]
        });

        let feature = this.state.selectedFeature

        if (feature) {
            this.setState({selectedFeature: null})
            this.props.setGeojsonInfo('', '', '')

            this.props.setBoolean('showNumberInput', false)
            overlay.setPosition(null);
        }

        this.state.drawnBuildings.getSource().clear()
        this.props.changeBoolean('clearBuildings')
        this.props.handleInputChange({
            'target': {
                'type': 'input',
                'name': 'drawnBuildings',
                'value': []
        }})
    }

    handleBuildingMapClick(event){
        if (!this.props.drawBuilding){
            this.setState({
                showPopup: true
            })
            let container = this.refs.popup
            let content_element = this.refs.popupContent

            let overlay = new Overlay({
                element: container,
                autoPan: true,
                offset: [0, -10]
            });
            this.state.map.addOverlay(overlay);

            let feature = this.state.map.forEachFeatureAtPixel(event.pixel,
                function(feature, layer) {
                    return feature;
                });

            if (feature && feature.get('_customType')) {
                this.setState({selectedFeature: feature})
                let center = getCenter(feature.getGeometry().getExtent())

                let _customType = feature.get('_customType')
                let typeName = ''
                if (_customType === 'buildingGeojson'){
                    typeName = 'Building'
                } else if (_customType === 'fencelineGeojson') {
                    typeName = 'Fenceline'
                } else if (_customType === 'drawnBuildings') {
                    typeName = 'User defined building'
                } else if (_customType === 'drawnFencelines') {
                    typeName = 'User defined fenceline'
                }
                let _customId = feature.get('_customId')
                let _customHeight = feature.get('_customHeight')

                let content = `<h4> ${typeName}: ${_customId} </h4> <p> Height: ${_customHeight}m</p>`

                content_element.innerHTML = content;
                overlay.setPosition(center);

                this.props.setGeojsonInfo(_customType, _customId, _customHeight)
                this.props.setBoolean('showNumberInput', true)

            } else {
                this.setState({selectedFeature: null})
                this.props.setGeojsonInfo('', '', '')

                this.props.setBoolean('showNumberInput', false)
                overlay.setPosition(null);
            }
        }
    }
    // Handle click events for Met Site Map Instances
    handleMetMapClick(event) {
        this.setState({
            showPopup: true
        })
        let container = this.refs.popup
        let content_element = this.refs.popupContent

        var overlay = new Overlay({
            element: container,
            autoPan: true,
            offset: [0, -10]
        });
        this.state.map.addOverlay(overlay);

        var feature = this.state.map.forEachFeatureAtPixel(event.pixel,
          function(feature, layer) {
            return feature;
          });
        if (feature) {
            var geometry = feature.getGeometry();
            var coord = geometry.getCoordinates();

            var content = '<h4>' + feature.get('name') + '</h4>';
            content += feature.get('description') !== null ? '<p>' + feature.get('description') + '</p>' : '';

            content_element.innerHTML = content;
            overlay.setPosition(coord);

            if ( feature.get('name') !== 'Facility Location'){
                this.props.handleInputChange({
                    target:{
                        value: feature.get('value'),
                        name: feature.get('stateMapping')
                    }
                })
            }

        } else {
            overlay.setPosition(null);
        }
    }

    mapFacilityLocation(map){
        let layersToRemove = [];
        map.getLayers().forEach(function (layer) {
            if (layer.get('name') !== undefined && layer.get('name') === 'facilityLocation') {
                layersToRemove.push(layer);
            }
        });

        let len = layersToRemove.length;
        for(let i = 0; i < len; i++) {
            map.removeLayer(layersToRemove[i]);
        }

        map.addLayer(new LayerVector({
            source: new VectorSource({
                features: [ new Feature({
                    geometry: new Point(fromLonLat([parseFloat(this.props.facilityLon), parseFloat(this.props.facilityLat)])),
                    name: 'Facility Location',
                    description: null
                })]
            }),
            style: [ new Style({
                image: new CircleStyle({
                    radius: 7,
                    fill: new Fill({color: 'green'}),

                })
            }) ],
            name: 'facilityLocation'
        }))
        map.setView( new View({
            center: fromLonLat([parseFloat(this.props.facilityLon), parseFloat(this.props.facilityLat)]),
            zoom: 13
        }));

        return map
    }

    mapFacilitySource(map){
        let layersToRemove = [];
        map.getLayers().forEach(function (layer) {
            if (layer.get('name') !== undefined && layer.get('name') === 'facilityPoints') {
                layersToRemove.push(layer);
            }
        });

        let len = layersToRemove.length;
        for(let i = 0; i < len; i++) {
            map.removeLayer(layersToRemove[i]);
        }

        Object.keys(this.props.facilitySource)
            .forEach(key => {
            map.addLayer(new LayerVector({
                source: new VectorSource({
                    features: [ new Feature({
                        geometry: new Point(fromLonLat([parseFloat(this.props.facilitySource[key]['lonUTMy']), parseFloat(this.props.facilitySource[key]['latUTMx'])])),
                        name: 'Point Sources',
                        description: this.props.facilitySource[key]['stackName']
                    })]
                }),
                style: [ new Style({
                    image: new CircleStyle({
                        radius: 5,
                        fill: new Fill({color: 'yellow'}),

                    })
                }) ],
                name: 'facilityPoints'
            }))
        })

        return map
    }

    mapUpperAirStations(){
        let markers = []
        this.props.upperAirStationList.forEach(station => {
            markers.push(new Feature({
                geometry: new Point(fromLonLat([station.latlon[1], station.latlon[0]])),
                name: station.name,
                description: `Distance: ${station.distance}km.`,
                value: JSON.stringify(station),
                stateMapping: 'selectedUpperAirStation'
            }))
        })

        var surfaceStationStyle = new Style({
            image: new CircleStyle({
                radius: 7,
                fill: new Fill({color: 'yellow'}),

            })
        })

        this.state.map.addLayer(new LayerVector({
            source: new VectorSource({
                features: markers
            }),
            style: [ surfaceStationStyle ],
            name: 'upperAirStations'
        }))
    }

    mapSurfaceStations() {
        let markers = []
        this.props.surfaceStationList.forEach(station => {
            markers.push(new Feature({
                geometry: new Point(fromLonLat([station.latlon[1], station.latlon[0]])),
                name: station.name,
                description: `Distance: ${station.distance}km.`,
                value: JSON.stringify(station),
                stateMapping: 'selectedSurfaceStation'
            }))
        })

        var surfaceStationStyle = new Style({
            image: new CircleStyle({
                radius: 7,
                fill: new Fill({color: 'blue'}),

            })
        })

        this.state.map.addLayer(new LayerVector({
            source: new VectorSource({
                features: markers
            }),
            style: [ surfaceStationStyle ],
            name: 'surfaceStations'
        }))
    }

}

export default Map;
